<template>
  <tfoot v-if="hasFooter">
    <tr>
      <td v-for="[columnKey, column] in footerColumnEntries" :key="columnKey">
        <bm-grid-footer-cell
          v-if="column.footer !== null"
          :footer="column.footer"
        />
      </td>
    </tr>
  </tfoot>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { BmGridColumnConfigurations } from "@/components/controls/grid/BmGridData";
import BmGridFooterCell from "@/components/controls/grid/BmGridFooterCell.vue";

interface BmGridTableFooterProps {
  visibleColumns: BmGridColumnConfigurations;
}

const props = defineProps<BmGridTableFooterProps>();

const footerColumnEntries = computed(() =>
  Object.entries(props.visibleColumns)
);

const hasFooter = computed(() =>
  footerColumnEntries.value.some(([, column]) => column.footer !== null)
);
</script>

<style scoped lang="sass">
@import "src/sass/typography"
@import "src/sass/colours"

@mixin contents-text
  @include bm-body2
  color: $bm-color-text01

tr
  height: 36px

td
  @include contents-text
  border-bottom: 1px solid #D1CFD7
</style>
